import React, { Component } from 'react';
import { TextField } from '@material-ui/core';
import "./InputField.scss";

class InputField extends Component {
	render() {
		return <TextField {...this.props} fullWidth variant="filled" className="input-field-wrapper" inputProps={{ className: "input-field", name: this.props.name, autoComplete: "off" }} />;
	}
}
 
export default InputField;